

































import ClientOnly from 'vue-client-only';
import { defineComponent, PropType } from '@vue/composition-api';
import { ProductBox } from '~/utils/types/Product';
import PLPProductBox from '../PLPProductBox.vue';
import CategoryPagination from './Pagination/CategoryPagination.vue';
import HTMLContent from '~/components/solepro/HTMLContent.vue';

export default defineComponent({
    name: 'CategoryProductList',
    components: {
        PLPProductBox,
        ClientOnly,
        CategoryPagination,
        HTMLContent
    },
    props: {
        firstEditorialBox: {
            type: String
        },
        secondEditorialBox: {
            type: String
        },
        firstEditorialBoxPosition: {
            type: Number
        },
        secondEditorialBoxPosition: {
            type: Number
        },
        products: {
            type: Array as PropType<ProductBox[]>,
            required: true,
        },
        pagination: {
            type: Object,
            required: true
        },
        goToPage: {
            type: Function,
            required: true
        },
        trackCard: {
            type: Function
        },
        footerDescription: {
            type: String
        },
        categoryDescription: {
            type: String
        }
    }
})
